import script from "./VContextMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./VContextMenu.vue?vue&type=script&lang=ts&setup=true"

import "./VContextMenu.vue?vue&type=style&index=0&id=36c8ab04&lang=sass"

const __exports__ = script;

export default __exports__